import Yup from 'utils/validation/yup-extensions';

export const FORM_KEYS = {
	CHALLENGE_QUESTION: 'challengeQuestion',
	SECRET_ANSWER: 'secretAnswer',
	VALIDATE_WITH_CHALLENGE_RESPONSE: 'validateWithChallengeResponse',
};

export const COMMON_QUESTIONS = [
	{
		value: 'What was the name of your first pet?',
		label: 'What was the name of your first pet?',
	},
	{
		value: 'What was the make of your first car?',
		label: 'What was the make of your first car?',
	},
	{
		value: "What was your favorite teacher's last name?",
		label: "What was your favorite teacher's last name?",
	},
	{
		value: 'In what city were your parents married?',
		label: 'In what city were your parents married?',
	},
	{
		value: 'What was the first concert or sporting event you attended?',
		label: 'What was the first concert or sporting event you attended?',
	},
	{
		value: 'What was the name of your first manager?',
		label: 'What was the name of your first manager?',
	},
	{
		value: 'What was the name of your favorite childhood book?',
		label: 'What was the name of your favorite childhood book?',
	},
	{
		value: 'What was the name of your childhood best friend?',
		label: 'What was the name of your childhood best friend?',
	},
	{
		value: 'What was your favorite vacation destination as a child?',
		label: 'What was your favorite vacation destination as a child?',
	},
];

export const FORM_INITIAL_VALUES = {
	[FORM_KEYS.CHALLENGE_QUESTION]: '',
	[FORM_KEYS.SECRET_ANSWER]: '',
	[FORM_KEYS.VALIDATE_WITH_CHALLENGE_RESPONSE]: false,
};

export const getFormValidationSchema = legacyQuestion =>
	Yup.object().shape({
		[FORM_KEYS.CHALLENGE_QUESTION]: Yup.string()
			.oneOf(
				[
					'',
					...COMMON_QUESTIONS.map(question => question.value),
					...(legacyQuestion ? [legacyQuestion] : []),
				],
				'Please select a valid challenge question.'
			)
			.required('Please select a challenge question.'),
		[FORM_KEYS.SECRET_ANSWER]: Yup.string()
			.required('Please provide a secret answer.')
			.max(50, 'Secret answer must be 50 characters or fewer.')
			.test(
				'not-whitespace-only',
				'Challenge answer cannot be only whitespace.',
				value => !!value && value.trim().length > 0
			),
		[FORM_KEYS.VALIDATE_WITH_CHALLENGE_RESPONSE]: Yup.boolean(),
	});